import {useEffect, useState} from 'react';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

/**
 * Fetch a single ICR document by its document id.
 * Returns: { data, loading, error }
 */
export function useIcr(icrId) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!icrId) {
            setData(null);
            setLoading(false);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);

        fetch(`${BASE}/api/intelligence-requests/${encodeURIComponent(icrId)}`, {headers: authHeaders()})
            .then((r) => r.status === 404 ? null : r.ok ? r.json() : Promise.reject(new Error(`${r.status}`)))
            .then((doc) => { setData(doc); setLoading(false); })
            .catch((err) => { setError(err); setLoading(false); });
    }, [icrId]);

    return {data, loading, error};
}
